module.exports = __webpack_public_path__ + "img/journal-bookmark.547cc0e2.svg";